var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBicycleFacilityRequestWhite({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.0722 23.7727C29.6531 23.7732 30.1236 24.2447 30.1236 24.8258V27.3583H32.9443C33.5254 27.3586 33.9973 27.8302 33.9973 28.4114C33.9969 28.9922 33.5251 29.4625 32.9443 29.4628H30.1236V32.2802C30.1236 32.8612 29.6531 33.3327 29.0722 33.3333C28.4908 33.3333 28.0191 32.8615 28.0191 32.2802V29.4628H25.4866L25.275 29.4417C24.7955 29.3436 24.4339 28.9198 24.4335 28.4114C24.4335 27.9026 24.7951 27.4775 25.275 27.3795L25.4866 27.3583H28.0191V24.8258C28.0191 24.2444 28.4908 23.7727 29.0722 23.7727Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.38631 8.33325C9.96747 8.33348 10.4377 8.8051 10.4377 9.38631V29.7362C10.4377 30.3175 9.96747 30.7891 9.38631 30.7893C8.80496 30.7893 8.33325 30.3176 8.33325 29.7362V9.38631C8.33325 8.80496 8.80496 8.33325 9.38631 8.33325Z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2105 25.1757C19.7917 25.1759 20.262 25.6476 20.262 26.2288V29.7379L20.2408 29.9495C20.1424 30.4286 19.7188 30.7891 19.2105 30.7893C18.7022 30.7891 18.2769 30.4288 18.1786 29.9495L18.1575 29.7379V26.2288C18.1575 25.6475 18.6294 25.1759 19.2105 25.1757Z",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2105 16.7545C19.7917 16.7547 20.262 17.2263 20.262 17.8075V21.3167L20.2408 21.5282C20.1425 22.0075 19.7188 22.3679 19.2105 22.3681C18.7021 22.3679 18.2769 22.0076 18.1786 21.5282L18.1575 21.3167V17.8075C18.1575 17.2263 18.6294 16.7547 19.2105 16.7545Z",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0347 8.33325C29.6159 8.33348 30.0862 8.8051 30.0862 9.38631V19.912C30.0862 20.4932 29.6159 20.9649 29.0347 20.9651C28.4536 20.9648 27.9817 20.4932 27.9817 19.912V9.38631C27.9817 8.80514 28.4536 8.33354 29.0347 8.33325Z",
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2105 8.33325C19.7917 8.33348 20.262 8.8051 20.262 9.38631V12.8954L20.2408 13.107C20.1425 13.5864 19.7189 13.9467 19.2105 13.9469C18.702 13.9468 18.2768 13.5865 18.1786 13.107L18.1575 12.8954V9.38631C18.1575 8.80503 18.6293 8.33336 19.2105 8.33325Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBicycleFacilityRequestWhite);
export default __webpack_public_path__ + "static/media/bicycle-facility-request-white.9f22601d5f571deda24278581dab224e.svg";
export { ForwardRef as ReactComponent };